import { ENV } from "../utils";
import { apiFetch } from "./httpClient";

export class Permission {
  /**
   * Fetches the list of permissions.
   */
  async getPermissions(section) {
    return apiFetch(`${ENV.API_ROUTES.PERMISSION}?section=${section}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  /**
   * Creates a new permission.
   */
  async createPermission(data) {
    return apiFetch(ENV.API_ROUTES.PERMISSION, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      expectedStatus: 201,
    });
  }

  /**
   * Updates an existing permission.
   */
  async updatePermission(permissionId, data) {
    return apiFetch(`${ENV.API_ROUTES.PERMISSION}/${permissionId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  /**
   * Deletes an existing permission.
   */
  async deletePermission(roleId) {
    return apiFetch(`${ENV.API_ROUTES.PERMISSION}/${roleId}`, {
      method: "DELETE",
    });
  }
}
